/**
 * Merges helpText from defaultFields into customFields
 * if helpText is missing (null or undefined).
 *
 * @param {Array} customFields - Array of custom form field configs
 * @param {Array} defaultFields - Array of default form field configs
 * @returns {Array} - Enriched array with helpText preserved or injected
 */
export default function mergeHelpText(customFields = [], defaultFields = []) {
  return customFields.map(customField => {
    const defaultField = defaultFields.find(def => def.field === customField.field);

    return {
      ...customField,
      helpText: customField.helpText ?? defaultField?.helpText,
    };
  });
}
